document.addEventListener('DOMContentLoaded', () => {

  document
    .querySelectorAll('[data-pnec]')
    .forEach(section => {

      const tabs =
        section.querySelectorAll('[data-pnec-tab]');

      const heroButtons =
        section.querySelectorAll('[data-pnec-open]');

      const slider =
        section.querySelector('.pnec-slider');

      let active = 'events';
      let startX = 0;


      function initContinuousRow(
        grid,
        cardSelector,
        direction,
        speed
      ) {

        if (
          !grid ||
          grid.dataset.pnecAutoRow === 'ready'
        ) {
          return;
        }


        const originals = [
          ...grid.querySelectorAll(
            `:scope > ${cardSelector}`
          )
        ];


        if (originals.length < 2) {
          return;
        }


        grid.dataset.pnecAutoRow =
          'ready';


        originals.forEach(card => {

          const clone =
            card.cloneNode(true);


          clone.dataset.pnecClone =
            'true';


          clone.setAttribute(
            'aria-hidden',
            'true'
          );


          clone
            .querySelectorAll(
              'a, button, input, select, textarea, [tabindex]'
            )
            .forEach(element => {

              element.setAttribute(
                'tabindex',
                '-1'
              );

            });


          grid.appendChild(clone);

        });


        let loopWidth = 0;
        let lastTime = null;
        let paused = false;
        let resumeTimer = null;
        let positionedRight = false;


        const reducedMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );


        function measure() {

          const first =
            originals[0];

          const firstClone =
            grid.querySelector(
              '[data-pnec-clone="true"]'
            );


          if (
            !first ||
            !firstClone
          ) {
            return;
          }


          loopWidth =
            firstClone.offsetLeft -
            first.offsetLeft;


          if (
            direction === 'right' &&
            !positionedRight &&
            loopWidth > 0
          ) {

            grid.scrollLeft =
              loopWidth;

            positionedRight =
              true;

          }

        }


        function normalize() {

          if (loopWidth <= 0) {
            return;
          }


          if (direction === 'right') {

            while (
              grid.scrollLeft <= 1
            ) {

              grid.scrollLeft +=
                loopWidth;

            }


            while (
              grid.scrollLeft >
              loopWidth
            ) {

              grid.scrollLeft -=
                loopWidth;

            }


            return;

          }


          while (
            grid.scrollLeft >=
            loopWidth
          ) {

            grid.scrollLeft -=
              loopWidth;

          }

        }


        function frame(time) {

          if (lastTime === null) {
            lastTime = time;
          }


          const delta =
            Math.min(
              time - lastTime,
              50
            );


          lastTime = time;


          if (
            !paused &&
            !document.hidden &&
            !reducedMotion.matches &&
            loopWidth > 0
          ) {

            const distance =
              speed *
              (
                delta /
                1000
              );


            if (
              direction === 'right'
            ) {

              grid.scrollLeft -=
                distance;

            } else {

              grid.scrollLeft +=
                distance;

            }


            normalize();

          }


          window.requestAnimationFrame(
            frame
          );

        }


        function pause() {

          paused = true;

          window.clearTimeout(
            resumeTimer
          );

        }


        function resumeSoon() {

          window.clearTimeout(
            resumeTimer
          );


          resumeTimer =
            window.setTimeout(
              () => {

                measure();
                normalize();

                paused = false;

              },
              900
            );

        }


        grid.addEventListener(
          'pointerdown',
          pause,
          {
            passive: true
          }
        );


        grid.addEventListener(
          'pointerup',
          resumeSoon,
          {
            passive: true
          }
        );


        grid.addEventListener(
          'pointercancel',
          resumeSoon,
          {
            passive: true
          }
        );


        /*
          Keep inner carousel swipes from switching
          the whole Events / Communities panel.
        */
        grid.addEventListener(
          'touchstart',
          event => {

            event.stopPropagation();
            pause();

          },
          {
            passive: true
          }
        );


        grid.addEventListener(
          'touchend',
          event => {

            event.stopPropagation();
            resumeSoon();

          },
          {
            passive: true
          }
        );


        grid.addEventListener(
          'wheel',
          () => {

            pause();
            resumeSoon();

          },
          {
            passive: true
          }
        );


        grid.addEventListener(
          'focusin',
          pause
        );


        grid.addEventListener(
          'focusout',
          resumeSoon
        );


        const observer =
          new ResizeObserver(
            () => {

              measure();
              normalize();

            }
          );


        observer.observe(grid);


        originals.forEach(card => {
          observer.observe(card);
        });


        window.requestAnimationFrame(
          () => {

            measure();

            window.requestAnimationFrame(
              () => {

                measure();

                window.requestAnimationFrame(
                  frame
                );

              }
            );

          }
        );

      }


      function initContinuousEventRows() {

        const eventsPanel =
          section.querySelector(
            '[data-pnec-panel="events"]'
          );


        if (!eventsPanel) {
          return;
        }


        const categoryGrid =
          eventsPanel.querySelector(
            '.pnec-category-grid'
          );


        const benefitGrid =
          eventsPanel.querySelector(
            '.pnec-benefit-grid'
          );


        /*
          TOP ROW:
          visual movement → RIGHT
        */


        /*
          BOTTOM ROW:
          visual movement → LEFT
        */

      }


      function setActive(name, scroll = false) {

        active = name;

        section.dataset.active = name;


        tabs.forEach(tab => {

          const selected =
            tab.dataset.pnecTab === name;

          tab.classList.toggle(
            'is-active',
            selected
          );

          tab.setAttribute(
            'aria-selected',
            selected
              ? 'true'
              : 'false'
          );

        });


        if (scroll) {

          section
            .querySelector('.pnec-switch-area')
            ?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });

        }

      }


      tabs.forEach(tab => {

        tab.addEventListener(
          'click',
          () => {
            setActive(
              tab.dataset.pnecTab
            );
          }
        );

      });


      heroButtons.forEach(button => {

        button.addEventListener(
          'click',
          () => {

            setActive(
              button.dataset.pnecOpen,
              true
            );

          }
        );

      });


      slider?.addEventListener(
        'touchstart',
        event => {

          startX =
            event.changedTouches[0]
              .clientX;

        },
        {
          passive: true
        }
      );


      slider?.addEventListener(
        'touchend',
        event => {

          const endX =
            event.changedTouches[0]
              .clientX;

          const distance =
            endX - startX;


          if (
            Math.abs(distance) < 55
          ) {
            return;
          }


          if (
            distance < 0 &&
            active === 'events'
          ) {

            setActive(
              'communities'
            );

          }


          if (
            distance > 0 &&
            active === 'communities'
          ) {

            setActive(
              'events'
            );

          }

        },
        {
          passive: true
        }
      );


      setActive('events');

      initContinuousEventRows();

    });

});

/* PNEC MOTION REPLACEMENT START */

(() => {
  'use strict';


  /*
    One controller owns ALL FOUR rails.

    42 is the known existing PeerNest motion value found
    in the current implementation.

    Events and Communities now use exactly the same speed.
  */

  const SPEED_PX_PER_SECOND = 42;


  /*
    REVERSED DIRECTION:

    CATEGORY / TOP ROW
        ← LEFT

    BENEFIT / BOTTOM ROW
        → RIGHT
  */

  const CONFIGS = [

    {
      selector:
        '.pnec-panel[data-pnec-panel="events"] .pnec-category-grid',

      direction:
        'left'
    },

    {
      selector:
        '.pnec-panel[data-pnec-panel="events"] .pnec-benefit-grid',

      direction:
        'right'
    },

    {
      selector:
        '.pnec-panel[data-pnec-panel="communities"] .pnec-category-grid',

      direction:
        'left'
    },

    {
      selector:
        '.pnec-panel[data-pnec-panel="communities"] .pnec-benefit-grid',

      direction:
        'right'
    }

  ];


  let states = [];


  const restoreRail = (rail) => {

    if (!rail) {
      return;
    }


    const track =
      rail.querySelector(
        ':scope > .pnec-motion-track'
      );


    if (track) {

      track
        .getAnimations()
        .forEach(
          animation => {
            animation.cancel();
          }
        );


      const originals =
        Array
          .from(track.children)
          .filter(
            item =>
              !item.hasAttribute(
                'data-pnec-motion-clone'
              )
          );


      rail.replaceChildren(
        ...originals
      );

    }


    rail
      .querySelectorAll(
        '[data-pnec-motion-clone]'
      )
      .forEach(
        clone => {
          clone.remove();
        }
      );

  };


  const cloneCard = (card) => {

    const clone =
      card.cloneNode(true);


    clone.setAttribute(
      'data-pnec-motion-clone',
      'true'
    );


    clone.setAttribute(
      'aria-hidden',
      'true'
    );


    if (
      clone.hasAttribute('id')
    ) {

      clone.removeAttribute(
        'id'
      );

    }


    clone
      .querySelectorAll('[id]')
      .forEach(
        element => {

          element.removeAttribute(
            'id'
          );

        }
      );


    clone
      .querySelectorAll(
        'a,button,input,select,textarea,[tabindex]'
      )
      .forEach(
        element => {

          element.setAttribute(
            'tabindex',
            '-1'
          );

        }
      );


    return clone;

  };


  const createRail = (
    rail,
    direction
  ) => {

    restoreRail(
      rail
    );


    const cards =
      Array.from(
        rail.children
      );


    if (
      cards.length < 2
    ) {

      return null;

    }


    const style =
      window.getComputedStyle(
        rail
      );


    const gap =
      parseFloat(
        style.columnGap
      )
      ||
      parseFloat(
        style.gap
      )
      ||
      16;


    const track =
      document.createElement(
        'div'
      );


    track.className =
      'pnec-motion-track';


    track.style.setProperty(
      '--pnec-motion-gap',
      `${gap}px`
    );


    cards.forEach(
      card => {

        track.appendChild(
          card
        );

      }
    );


    const clones =
      cards.map(
        card => {

          const clone =
            cloneCard(
              card
            );


          track.appendChild(
            clone
          );


          return clone;

        }
      );


    rail.appendChild(
      track
    );


    let animation =
      null;


    const start = () => {

      if (animation) {

        animation.cancel();

      }


      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {

        return;

      }


      if (
        !cards[0]
        ||
        !clones[0]
      ) {

        return;

      }


      /*
        Exact distance of one complete sequence.
      */

      const span =
        clones[0].offsetLeft
        -
        cards[0].offsetLeft;


      if (
        span <= 1
      ) {

        return;

      }


      /*
        SAME physical speed for every row.
      */

      const duration =
        (
          span
          /
          SPEED_PX_PER_SECOND
        )
        *
        1000;


      let frames;


      if (
        direction ===
        'right'
      ) {

        frames = [
          {
            transform:
              `translate3d(${-span}px,0,0)`
          },
          {
            transform:
              'translate3d(0px,0,0)'
          }
        ];

      } else {

        frames = [
          {
            transform:
              'translate3d(0px,0,0)'
          },
          {
            transform:
              `translate3d(${-span}px,0,0)`
          }
        ];

      }


      animation =
        track.animate(
          frames,
          {
            duration,
            iterations:
              Infinity,
            easing:
              'linear'
          }
        );

    };


    /*
      Let actual card geometry settle first.
    */

    requestAnimationFrame(
      () => {

        requestAnimationFrame(
          start
        );

      }
    );


    /*
      Pause while user interacts.
    */

    const pause = () => {

      if (animation) {

        animation.pause();

      }

    };


    const resume = () => {

      window.setTimeout(
        () => {

          if (animation) {

            animation.play();

          }

        },
        650
      );

    };


    rail.addEventListener(
      'pointerdown',
      pause,
      {
        passive: true
      }
    );


    rail.addEventListener(
      'pointerup',
      resume,
      {
        passive: true
      }
    );


    rail.addEventListener(
      'pointercancel',
      resume,
      {
        passive: true
      }
    );


    rail.addEventListener(
      'touchstart',
      pause,
      {
        passive: true
      }
    );


    rail.addEventListener(
      'touchend',
      resume,
      {
        passive: true
      }
    );


    return {
      rail,
      track
    };

  };


  const init = () => {

    states.forEach(
      state => {

        if (
          !state
          ||
          !state.track
        ) {

          return;

        }


        state
          .track
          .getAnimations()
          .forEach(
            animation => {

              animation.cancel();

            }
          );

      }
    );


    states =
      [];


    CONFIGS.forEach(
      config => {

        document
          .querySelectorAll(
            config.selector
          )
          .forEach(
            rail => {

              const state =
                createRail(
                  rail,
                  config.direction
                );


              if (state) {

                states.push(
                  state
                );

              }

            }
          );

      }
    );


    console.info(
      '[PeerNest Events/Communities] top LEFT | bottom RIGHT | 42px/s'
    );

  };


  let resizeTimer =
    null;


  const rebuild = () => {

    window.clearTimeout(
      resizeTimer
    );


    resizeTimer =
      window.setTimeout(
        init,
        180
      );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );

  } else {

    init();

  }


  window.addEventListener(
    'load',
    rebuild,
    {
      once: true
    }
  );


  window.addEventListener(
    'resize',
    rebuild
  );


  document.addEventListener(
    'shopify:section:load',
    rebuild
  );

})();

/* PNEC MOTION REPLACEMENT END */
